import React, { useState, useEffect, useRef } from 'react';
import { Bar } from 'react-chartjs-2';
import 'chartjs-adapter-moment';

const CostData = () => {
  const [data, setData] = useState([]);
  const [csvCostData, setCsvCostData] = useState([]);
  const [montantElectricity, setMontantElectricity] = useState('');
  const [montantGaz, setMontantGaz] = useState('');
  const [scope, setScope] = useState('');
  const [hasMontantElectricityError, setHasMontantElectricityError] =useState(true);
  const [hasMontantGazError, setHasMontantGazError] = useState(true);
  const [showError, setShowError] = useState(false);
  const csvRef = useRef(null);

  useEffect(() => {
    var dayElem = document.getElementById('day');
    var monthElem = document.getElementById('month');
    var yearElem = document.getElementById('year');

    monthElem.addEventListener('click', function () {
      setScope('month');
      monthElem.classList.add('active');
      yearElem.classList.remove('active');
      dayElem.classList.remove('active');
    });

    yearElem.addEventListener('click', function () {
      setScope('year');
      monthElem.classList.remove('active');
      yearElem.classList.add('active');
      dayElem.classList.remove('active');
    });

    dayElem.addEventListener('click', function () {
      setScope('day');
      monthElem.classList.remove('active');
      yearElem.classList.remove('active');
      dayElem.classList.add('active');
    });

    try {
      const getFacture = async () => {
        const response = await fetch('https://fusionsmart.seifeddineslimene.com/api/facture', {
          method: 'GET',
          headers: {
            'Content-type': 'application/json',
          },
        });
        const data = await response.json();
        setData(data);
      };

      getFacture();

      const getCSVCostData = async () => {
        const response = await fetch('https://fusionsmart.seifeddineslimene.com/api/get', {
          method: 'GET',
          headers: {
            'Content-type': 'application/json',
          },
        });
        const data = await response.json();
        setCsvCostData(data);
      };

      getCSVCostData();
      getFacture();
    } catch (error) {
      console.error(error);
    }
  }, []);

  const deleteCsv = async (e) => {
    e.preventDefault();
    try {
      setShowError(false);
      await fetch('https://fusionsmart.seifeddineslimene.com/api/deleteAllCsvData', {
        method: 'DELETE',
      });
      setCsvCostData([]);
    } catch (error) {
      console.error(error);
    }
  };

  const factureData = async (e) => {
    e.preventDefault();
    if (hasMontantGazError || hasMontantElectricityError) {
      setShowError(true);
    } else {
      try {
        setShowError(false);
        await fetch('https://fusionsmart.seifeddineslimene.com/api/facture', {
          method: 'POST',
          headers: {
            'Content-type': 'application/json',
          },
          body: JSON.stringify({
            montantElectricity: montantElectricity + '$',
            montantGaz: montantGaz + '$',
          }),
        });

        setData([
          ...data,
          { date: new Date(), montantElectricity, montantGaz },
        ]);
      } catch (error) {
        console.error(error);
      }
    }
  };

  
  const CSVSubmit = async (e) => {
    e.preventDefault();
    let upload = await uploadFile();
    if (upload.error === 0) {
      setCsvCostData(upload.costCsvData);
    } else if (upload.error === 1) {
      alert('File uploading failed - ' + upload.message);
    }
  };


  const uploadFile = async () => {
    let return_data;
    try {
      if (csvRef.current.files.length === 0) {
        throw new Error('No file selected');
      } else {
        let data = new FormData();

        data.append('csvFile', csvRef.current.files[0]);

        const response = await fetch('https://fusionsmart.seifeddineslimene.com/api/upload', {
          method: 'POST',
          body: data,
        });

        if (response.status !== 200) {
          throw new Error('HTTP response code !== 200');
        }

        return_data = await response.json();

        if (return_data.error === 1) throw new Error(return_data.message);
      }
    } catch (error) {
      return_data = { error: 1, message: error.message };
    }
    return return_data;
  };

  const chartData = {
    labels:
      csvCostData.length !== 0
        ? csvCostData.map((entry) => new Date(entry.date).toLocaleDateString())
        : data.map((entry) => new Date(entry.date).toLocaleDateString()), // Use date on x-axis
    datasets: [
      {
        label: 'Electricity',
        data:
          csvCostData.length !== 0
            ? csvCostData.map((entry) => entry?.montantElectricity)
            : data.map((entry) => entry?.montantElectricity?.split('$')[0]),
        backgroundColor: 'rgba(75, 60, 170, 0.6)',
      },
      {
        label: 'Gas',
        data:
          csvCostData.length !== 0
            ? csvCostData.map((entry) => entry?.montantGas)
            : data.map((entry) => entry?.montantGas?.split('$')[0]),
        backgroundColor: 'rgba(255, 89, 150, 0.6)',
      },
    ],
  };

  const options = {
    scales: {
      x: {
        type: 'time', // Use time scale for x-axis
        time: {
          parser: 'MM/DD/YYYY', // Use your date format here
          unit: scope,
          displayFormats: {
            [scope]:
              scope === 'day'
                ? 'DD MMM YYYY'
                : scope === 'month'
                ? 'MMM YYYY'
                : 'YYYY', // Format to display on the x-axis
          },
        },
      },
      y: {
        beginAtZero: true,
      },
    },
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom',
      },
      title: {
        display: true,
        text: 'Factures chart',
      },
    },
  };

  const handleChangeMontant = (e) => {
    if (e.target.name === 'montantElectricity') {
      setShowError(false);
      if (e.target.value.length === 0 || isNaN(parseInt(e.target.value))) {
        setHasMontantElectricityError(true);
        setMontantElectricity(e.target.value);
      } else {
        setHasMontantElectricityError(false);
        setMontantElectricity(e.target.value);
      }
    } else {
      setShowError(false);
      if (e.target.value.length === 0 || isNaN(parseInt(e.target.value))) {
        setHasMontantGazError(true);
        setMontantGaz(e.target.value);
      } else {
        setHasMontantGazError(false);
        setMontantGaz(e.target.value);
      }
    }
  };

  const resetForm = (e) => {
    e.preventDefault();
    setShowError(false);
    setHasMontantElectricityError(true);
    setHasMontantGazError(true);
    setMontantElectricity('');
    setMontantGaz('');
  };

  console.log({ csvCostData, data, chartData });

  return (
    <div
      id='content-body'
      className='col-12 col-md-9 col-xl-10 pl-4 pr-4 bd-content'
    >
      <div className='mb-8 pt-4 mt-3' style={{ height: '60px' }}>
        <div className='col-md-12 pt-4'>
          <h2>Cost Management</h2>
        </div>
      </div>
      <div className='mb-5'>
        <form
          onSubmit={factureData}
          className='mt-5 mb-3 d-flex justify-content-center align-items-center'
        >
          <div className='me-2'>
            <span className='d-inline-block me-2'>Montant Electricité</span>
            <input
              type='text'
              value={montantElectricity}
              name='montantElectricity'
              onChange={handleChangeMontant}
              placeholder='Montant Electricité'
            />
          </div>
          <div className='me-2'>
            <span className='d-inline-block me-2'>Montant Gaz</span>
            <input
              type='text'
              value={montantGaz}
              name='montantGaz'
              onChange={handleChangeMontant}
              placeholder='Montant Gaz'
            />
          </div>

          
          <button type='submit' className='me-2'>
            Envoyer
          </button>
          <button onClick={resetForm}>Vider Les Champs</button>
        </form>
        {showError && (
          <p className='text-center text-danger fw-bold'>
            *Renseigner tous les champs avant de valider, tous les champs
            doivent être des nombres!
          </p>
        )}
      </div>

      <div className='mb-5'>
        <form
          onSubmit={CSVSubmit}
          className='mt-5 mb-3 d-flex justify-content-center align-items-center'
        >
          <div className='me-2'>
            <span className='d-inline-block me-1'>CSV</span>
            <input
              ref={csvRef}
              id='cost-csv'
              accept='text/csv'
              type='file'
              name='cost-csv'
            />
          </div>
          <button type='submit' className='me-2'>
            Envoyer CSV
          </button>
          <button className='me-2' onClick={deleteCsv}>
            Delete CSV
          </button>
        </form>
      </div>

      <div className='mb-5 text-center'>
        <ul className='buttonwrapper'>
          <li id='day' className='active'>
            <label id='l1'>DAY</label>
          </li>
          <li id='month'>
            <label id='l2'>MONTH</label>
          </li>
          <li id='year'>
            <label id='l3'>YEAR</label>
          </li>
        </ul>
      </div>

      <div>{data.length > 0 && <Bar data={chartData} options={options} />}</div>
      <div className='row'>
        <div className='col-md-12 pb-3'>
          <span className='footer-text-1'>Energy Tip: </span>
          <span className='footer-text-2'>
            On all days, turning off or unplugging electrical devices when
            you're not at departments can help reduce your energy costs by
            approximately 10 percent.
          </span>
        </div>
      </div>
    </div>
  );
};

export default CostData;



